import { render, staticRenderFns } from "./envNotice.vue?vue&type=template&id=dda96218&scoped=true"
import script from "./envNotice.vue?vue&type=script&lang=js"
export * from "./envNotice.vue?vue&type=script&lang=js"
import style0 from "./envNotice.vue?vue&type=style&index=0&id=dda96218&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda96218",
  null
  
)

export default component.exports